export class Queue<T> {
  private _queue: T[];

  constructor(queue?: T[]) {
    this._queue = queue || [];
  }
  getQueue() {
    return this._queue;
  }
  enqueue(item: T) {
    if (Array.isArray(item)) {
      this._queue.push(...item);
    } else {
      this._queue.push(item);
    }
  }

  dequeue(): T | undefined {
    return this._queue.shift();
  }

  clear() {
    this._queue = [];
  }

  get count(): number {
    return this._queue.length;
  }
}
